<template>
    <ValidationProvider
        v-slot="{ errors }"
        :name="label"
        :vid="name"
        :rules="rules"
    >
        <TextField
            v-model="innerValue"
            :errors="errors"
            v-bind="{...$attrs, ...$props}"
        />
    </ValidationProvider>
</template>

<script>
import ValidationProvider from '@/validator';
import TextField from '../TextField.vue';
import fieldMixin from '@/mixins/fieldMixin';
export default {
    components: {
        ValidationProvider,
        TextField,
    },
    mixins: [fieldMixin],
    props: {
        rules: {
            type: String,
            default: '',
        },
    },
};
</script>

<style></style>
